import { Components } from '@mui/material/styles'

export const MuiGridOverrides: Components['MuiGrid'] = {
  styleOverrides: {
    container: {
      margin: 0,
      width: '100%',
    },
    item: {
      padding: '0 8px', // Mixed values for specific layout
    },
  },
}
